<template>
  <div class="Reports__View">
    <EntityListLayout v-if="tabs.length" :tabs="tabs" ref="entity" @onNewEntitySave="onNewEntitySave">
      <template #title>וידאו</template>
      <template #button>
        <a @click="addLessonVideo" class="link-button">
          שיוך וידאו ליחידת הלימוד
        </a>
      </template>
      <template v-slot:counter="slotProps">
        סה"כ <b>{{ getTotalRecords(slotProps) }} </b>
      </template>
    </EntityListLayout>
  </div>
</template>
<script>
import LessonService from "@/services/LessonService";
import EntityListLayout from "@/components/EntityListLayout.vue";
import VideoEntity from "@/views/VideoEntity.vue";
import DialogAddLessonVideo from '@/components/DialogAddLessonVideo.vue';
import {
  ModalProgrammatic as Modal,
} from 'buefy';
import FieldService from "@/services/FieldService";
import FilterService from "@/services/FilterService";

export default {
  name: "Reports",
  data() {
    return {
      tabs: [],
    };
  },
  components: {
    EntityListLayout,
  },
  computed: {
    courseId() {
      return this.$store.state.auth.course.id;
    },
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      const lessonsFields = FieldService.list("videos");
      const reportsfilters = FilterService.list();

      const sideViewEntity = {
        component: VideoEntity,
        preview: true,
        readOnly: !this.isAdmin,
        title: "פרטי סרטון",
        recordUrl: "videos",
        recordTitle: "הצג סרטון",
        hideRecord: true
      };
      const fields = [
        { ...lessonsFields.Id, checked: true },
        { ...lessonsFields.ExternalId, checked: true },
        { ...lessonsFields.LessonId, checked: true },
        { ...lessonsFields.VideoId, checked: true },
        { ...lessonsFields.SortOrder, checked: true },
        { ...lessonsFields.Name, checked: true },
        { ...lessonsFields.Link, checked: true },
        { ...lessonsFields.LawCollectionName, checked: true },
        { ...lessonsFields.VerdictCollectionName, checked: true },
        { ...lessonsFields.Category, checked: true },
        { ...lessonsFields.VideoCategory, checked: true },
        { ...lessonsFields.Status, checked: true },
        { ...lessonsFields.IsInteractiveVideo, checked: true },
      ];

      this.tabs = [
        {
          id: "AllVideos",
          isPrimary: true,
          title: "כל הסרטונים",
          getDataAsync: this.getAllVideos,
          perPage: 100,
          fields,
          filters: [
            { ...reportsfilters.Lessons, selected: this.$route.params.LessonIds },
          ],
          sortField: "Id",
          sortOrder: "desc",
          checkableRows: false,
          fastSearch: true,
          fastSearchOptions: {
            propName: "Terms",
            label: "חיפוש לפי מזהה יחידה",
          },
          sideViewEntity,
        },
      ];
    },
    addLessonVideo() {
      Modal.open({
        component: DialogAddLessonVideo,
        props: {
          store: this.$store
        },
        canCancel: false,
        hasModalCard: true,
        trapFocus: true,
      });
    },
    onNewEntitySave() {
      this.$refs.entity.onNewEntityCancel();
    },
    getAllVideos({ ...rest }) {
      return LessonService.getAdminVideos(this.courseId, rest).then((r) => ({
        data: {
          TotalResults: r.data.totalResults,
          Items: r.data.items,
        },
      }));
    },
    getTotalRecords(slotProps) {
      return slotProps.tab && slotProps.tab.total && slotProps.tab.total;
    },
  },
};
</script>
<style scoped lang="scss">
.link-button {
  background: #00427e;
  border: none;
  border-radius: 3px;
  padding: 14px 25px;
  color: white;
  cursor: pointer;
}
</style>
